import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {environment} from "../../environments/environment";
import {AppResponse} from "./app-response.model";
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonHttpService {

  constructor(private http: HttpClient) {
  }

  get<T>(path: string): Observable<AppResponse<T>> {
    return this.request("GET", path);
  }

  post<T>(path: string, body: any, params?: any): Observable<AppResponse<T>> {
    return this.request("POST", path, params, body);
  }

  handleError(error: Response): Observable<any> { // The return type is ErrorObservable, which is a specialization of Observable<any>
    return of(error);
  }


  request<T>(method: string, path: string, params?: any, body?: any, headers?: HttpHeaders): Observable<any> {
    const req = this.http.request<T>(method, environment.apiUrl + path, {body, headers, params});
    return req.pipe(
      map(r => AppResponse.success(r)),
      catchError(err => of(AppResponse.failure<T>(err)))
    );
  }

  requestBlob(method: string, path: string, params?: any, body?: any, headers?: HttpHeaders): Observable<any> {
    return this.http.request(method, environment.apiUrl + path, {body, headers, params, responseType: "blob"}).pipe(
      map(r => AppResponse.success(r)),
      catchError(err => of(AppResponse.failure<Blob>(err)))
    );
  }

}

export const optimistic = <T>(source: Observable<AppResponse<T>>) => new Observable<T>(observer => {
  return source.subscribe(
    (response) => {
      if (response.success) {
        observer.next(response.body);
      } else {
        observer.error(response.httpError);
      }
    },
    (err) => observer.error(err),
    () => observer.complete()
  );
});
